import { axios } from '../../../plugins/axios'

export default {
  namespaced: true,

  state: {
    armas: [],
    selectedArma: null,
  },

  getters: {
    getArmas: (state) => {
      return state.armas
    },
    getSelectedArma: (state) => {
      return state.selectedArma
    },
  },

  mutations: {
    SET_ARMAS: (state, armas) => {
      state.armas = armas
    },
    SET_SELECTED_ARMA: (state, arma) => {
      state.selectedArma = {
        ...arma,
        fk_idTipo: arma.fk_idTipo ?? arma.CatClase?.fk_idTipo ?? null,
        fk_idClase: arma.fk_idClase ?? arma.CatClase?.id ?? null,
        fk_idCalibre: arma.fk_idCalibre ?? arma.CatCalibre?.id ?? null,
        fk_idMarca: arma.fk_idMarca ?? arma.CatModelo?.fk_idMarca ?? arma.CatModelo?.CatMarca?.id ?? null,
        fk_idModelo: arma.fk_idModelo ?? arma.CatModelo?.id ?? null,
        fk_idCatProcedenciaArma: arma.fk_idCatProcedenciaArma ?? arma.CatProcedenciaArma?.id ?? null,
      }
    },
  },

  actions: {
    fetchArmas: async function ({ commit }) {
      try {
        const response = await axios.get('/PoliciaCuadrantes/Armeria/armas/')
        commit('SET_ARMAS', response.data.data)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al obtener armas', { root: true })
        throw error
      }
    },

    saveArma: async function ({ commit }, arma) {
      try {
        await axios.post('/PoliciaCuadrantes/Armeria/armas/', arma)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al guardar arma', { root: true })
        throw error
      }
    },

    updateArma: async function ({ commit }, arma) {
      try {
        await axios.put('/PoliciaCuadrantes/Armeria/armas/' + arma.idArma, arma)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar arma', { root: true })
        throw error
      }
    },

    updateEstatusArma: async function (context, arma) {
      try {
        await axios.put('/PoliciaCuadrantes/Armeria/armas/' + arma.idArma + '/estatus', {
          fk_idEstatus: arma.fk_idEstatus,
        })
        context.commit('SET_SNACKBAR_MESSAGE', 'Estatus de arma cambiado correctamente.', { root: true })
      } catch (error) {
        context.commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar estatus del arma', { root: true })
        throw error
      }
    },
  },
}
